import { requireAdmin } from '@/plugins/router';
import { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';
import ExternalEventEventCreatePage from './pages/ExternalEventEventCreatePage.vue';
import ExternalEventEventPage from './pages/ExternalEventEventPage.vue';
import ExternalEventOverviewPage from './pages/ExternalEventOverviewPage.vue';
import ExternalEventSeriesCreatePage from './pages/ExternalEventSeriesCreatePage.vue';
import ExternalEventSeriesPage from './pages/ExternalEventSeriesPage.vue';
import ExternalEventEventAllocationsTab from './tabs/event/ExternalEventEventAllocationsTab.vue';
import ExternalEventEventMasterdataTab from './tabs/event/ExternalEventEventMasterdataTab.vue';
import ExternalEventEventVariantsTab from './tabs/event/ExternalEventEventVariantsTab.vue';
import ExternalEventSeriesEventsTab from './tabs/series/ExternalEventSeriesEventsTab.vue';
import ExternalEventSeriesMasterDataTab from './tabs/series/ExternalEventSeriesMasterDataTab.vue';

export const externalEventRoutes = <RouteRecordRaw[]>[
    {
        path: '/external-events',
        children: [
            {
                path: '',
                name: 'external-events',
                component: ExternalEventOverviewPage,
            },
            {
                path: 'series/add',
                name: 'external-event-series-add',
                component: ExternalEventSeriesCreatePage,
                beforeEnter: requireAdmin,
            },
            {
                path: 'event/add',
                name: 'external-event-add',
                component: ExternalEventEventCreatePage,
                props: (route: RouteLocationNormalized) => ({
                    seriesId: route.query.seriesId,
                    nameShort: route.query.nameShort,
                    nameLong: route.query.nameLong,
                }),
                beforeEnter: requireAdmin,
            },
            {
                path: 'series/:seriesId',
                component: ExternalEventSeriesPage,
                props: true,
                children: [
                    {
                        path: '',
                        name: 'external-event-series',
                        redirect: { name: 'external-event-series-events-tab' },
                    },
                    {
                        path: 'events',
                        name: 'external-event-series-events-tab',
                        component: ExternalEventSeriesEventsTab,
                        props: true,
                    },
                    {
                        path: 'masterdata',
                        name: 'external-event-series-masterdata-tab',
                        component: ExternalEventSeriesMasterDataTab,
                        props: true,
                    },
                ],
            },
            {
                path: 'event/:eventId',
                component: ExternalEventEventPage,
                props: true,
                children: [
                    {
                        path: '',
                        name: 'external-event-event',
                        redirect: { name: 'external-event-event-masterdata-tab' },
                    },
                    {
                        path: 'masterdata',
                        name: 'external-event-event-masterdata-tab',
                        component: ExternalEventEventMasterdataTab,
                        props: true,
                    },
                    {
                        path: 'allocations',
                        name: 'external-event-event-allocations-tab',
                        component: ExternalEventEventAllocationsTab,
                        props: true,
                    },
                    {
                        path: 'variants',
                        name: 'external-event-event-variants-tab',
                        component: ExternalEventEventVariantsTab,
                        props: true,
                    },
                ],
            },
        ],
    },
];
